export default class BuildInfo { static buildNumber = "OpsBoard_multi-tenant_20260421.1"; } 
